import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcBilling = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        stroke="currentColor"
        strokeWidth={1.5}
        d="M25.25 6.75v14.5H3.75V6.75h21.5Z"
      />
      <circle
        cx={14.636}
        cy={13.636}
        r={2.886}
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <circle cx={6.636} cy={9.636} r={1} fill="currentColor" />
      <circle cx={22.091} cy={17.727} r={1} fill="currentColor" />
      <path
        stroke="currentColor"
        strokeWidth={1.5}
        d="M26 11.117h3.412v14.414H7.545V22"
      />
    </g>
  </svg>
);
export default SvgIcBilling;
